import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { Col, Row, Card, Form} from 'antd'
import { RTLButton } from '../RTLKit';

/* ------ Field -------- */
import LoginField from '../formFields/LoginField';

/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/loginValidate';
import WarnForm     from './parts/loginWarn';

class Login extends Component {
    constructor(props) {
        super(props);
        this.props.onPageLoad('LoginPage');
        this.state = {
            username:'',
            password:''
        }
    };

    componentWillMount() {
    }

    onFormSubmit(value)
    {
        this.props.handleSubmit(value);
    }

    render () {
        return(
            <Row type="flex" justify="space-around" align="middle">
                <Col md={6} sm={24}>
                    <Card style={{marginTop: '30%'}}>
                        <img src={require(`../../assets/image/logo.png`)} alt="" style={{marginBottom: '20px'}}/>
                        <Form onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                            <Form.Item>
                                <Field
                                    name="username"
                                    component={LoginField}
                                    type="text"
                                    placeholder="نام کاربری"
                                />
                            </Form.Item>

                            <Form.Item>
                                <Field
                                    name="password"
                                    component={LoginField}
                                    type="password"
                                    placeholder="رمز عبور"
                                />
                            </Form.Item>

                            <Form.Item>
                                <RTLButton loading={this.props.auth.isLoginProgressing} type="primary" block shape="round" htmlType="submit" className="login-form-button">
                                    ورود به سامانه
                                </RTLButton>
                                {/*<a style={{float: 'right'}} href="/">فراموشی رمز عبور</a>*/}
                                {/*<a href="/" style={{float: 'left'}}>ثبت نام کنید </a>*/}
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        );
    }
};

export default Login = reduxForm({
    form: 'login',
    validate: ValidateForm,
    warn: WarnForm
})(Login)

